// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup-notices{padding-bottom:40px}.popup-notices .popup-btn{width:auto!important;height:48px!important;font-weight:400;padding:0 20px!important}.popup-notices .popup-btn svg{margin-right:10px}@media(max-width:600px){.popup-notices .popup-notices__top{display:grid!important;grid-gap:10px;gap:10px}}.popup-notices__top{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
